import { Box } from "@chakra-ui/react";
import CDS from "design-system";

interface DayHeadersProps {
  startDate: Date;
  numDays: number;
  slotHeight: number;
}

export default function DayHeaders({ startDate, numDays, slotHeight }: DayHeadersProps) {
  const getDayHeader = (dayIndex: number) => {
    const date = new Date(startDate);
    date.setDate(date.getDate() + dayIndex);

    const dayName = date.toLocaleDateString("en-US", { weekday: "short" });
    const dayNumber = date.getDate();
    const month = date.toLocaleDateString("en-US", { month: "short" });

    return {
      dayName,
      dayNumber,
      month,
      isToday: date.toDateString() === new Date().toDateString(),
    };
  };

  return (
    <Box
      flex={1}
      height={`${slotHeight}px`}
      display="grid"
      gridTemplateColumns={`repeat(${numDays}, 1fr)`}
    >
      {Array.from({ length: numDays }, (_, dayIndex) => {
        const dayInfo = getDayHeader(dayIndex);
        return (
          <Box
            key={dayIndex}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            borderLeftWidth={dayIndex > 0 ? "1px" : "0"} borderLeftColor="gray.200"
            bg={dayInfo.isToday ? "blue.50" : "transparent"}
            color={dayInfo.isToday ? "blue.700" : "gray.700"}
            fontSize="xs"
            fontWeight="medium"
          >
            <CDS.Text10 fontWeight="semibold" mb={0}>
              {dayInfo.dayName}
            </CDS.Text10>
            <CDS.Text10 color={dayInfo.isToday ? "blue.600" : "gray.600"}>
              {dayInfo.month}
              {" "}
              {dayInfo.dayNumber}
            </CDS.Text10>
          </Box>
        );
      })}
    </Box>
  );
}
